export default __webpack_public_path__ + "static/media/02_plane.6cccb9ce.jpg";